"use strict";var e=require("styled-components").css`
    border: solid 1px ${({theme:e})=>e.colors.grey[300]};
    border-radius: ${({theme:e})=>e.borderRadiuses.medium};
    padding: 20px;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    position: relative;

    .DXPlannerField-grid {
        display: grid;
        grid-row-gap: 10px;

        @media (min-width: ${({theme:e})=>e.breakpoints.small}) {
            grid-template-columns: auto max-content;
        }
    }

    .DXButton {
        grid-column-gap: 3px;
        top: 0;
        right: 0;

        svg {
            height: 16px;
        }
    }

    ${({answer:e,theme:i})=>e&&`\n            @media (max-width: calc(${i.breakpoints.small} + 1px)) {\n                .DXButton {\n                    position: absolute;\n                    top: 20px;\n                    right: 20px;\n    \n                    svg {\n                        height: 20px;\n                        width: 20px\n                    }\n    \n                    .hide-on-mobile {\n                        display: none;\n                    }\n                }\n            }\n        `}
`;module.exports=e;
//# sourceMappingURL=styles.js.map
